"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, GlobalAlert, HStack, Select, VStack } from "@navikt/ds-react";
import { useRouter } from "next/navigation";
import { useState, useTransition } from "react";
import { DEMO_SCENARIO_COOKIE, DEMO_TILTAKSPAKKE_VARIANT_COOKIE, DEMO_TILTAKSPAKKE_VARIANT_OPTIONS, type DemoScenario, type DemoScenarioOption, type DemoTiltakspakkeVariant, getAvailableDemoScenarioOptions, parseDemoScenario, parseDemoTiltakspakkeVariant, resolveDemoScenario } from "@/common/demoScenario";
type DemoBannerProps = {
  scenarios: DemoScenarioOption[];
  initialScenario: DemoScenario;
  initialVariant: DemoTiltakspakkeVariant;
};
export function DemoBanner(t0) {
  const $ = _c(83);
  const {
    scenarios,
    initialScenario,
    initialVariant
  } = t0;
  const router = useRouter();
  const [scenario, setScenario] = useState(initialScenario);
  const [variant, setVariant] = useState(initialVariant);
  const [isPending, startTransition] = useTransition();
  let T0;
  let T1;
  let T2;
  let T3;
  let T4;
  let T5;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== isPending || $[1] !== router || $[2] !== scenario || $[3] !== scenarios || $[4] !== variant) {
    const availableScenarios = getAvailableDemoScenarioOptions(scenarios, variant);
    let t18;
    if ($[28] !== router) {
      t18 = function applySelection(nextScenario, nextVariant) {
        setScenario(nextScenario);
        setVariant(nextVariant);
        const secure = window.location.protocol === "https:" ? "; Secure" : "";
        document.cookie = `${DEMO_SCENARIO_COOKIE}=${nextScenario}; path=/; SameSite=Lax${secure}`;
        document.cookie = `${DEMO_TILTAKSPAKKE_VARIANT_COOKIE}=${nextVariant}; path=/; SameSite=Lax${secure}`;
        startTransition(() => {
          router.refresh();
        });
      };
      $[28] = router;
      $[29] = t18;
    } else {
      t18 = $[29];
    }
    const applySelection = t18;
    let t19;
    if ($[30] !== applySelection || $[31] !== scenario || $[32] !== scenarios) {
      t19 = function handleVariantChange(value) {
        const nextVariant_0 = parseDemoTiltakspakkeVariant(value);
        const nextScenario_0 = resolveDemoScenario(scenarios, scenario, nextVariant_0);
        applySelection(nextScenario_0, nextVariant_0);
      };
      $[30] = applySelection;
      $[31] = scenario;
      $[32] = scenarios;
      $[33] = t19;
    } else {
      t19 = $[33];
    }
    const handleVariantChange = t19;
    let t20;
    if ($[34] !== applySelection || $[35] !== scenarios || $[36] !== variant) {
      t20 = function handleScenarioChange(value_0) {
        const nextScenario_1 = resolveDemoScenario(scenarios, parseDemoScenario(value_0), variant);
        applySelection(nextScenario_1, variant);
      };
      $[34] = applySelection;
      $[35] = scenarios;
      $[36] = variant;
      $[37] = t20;
    } else {
      t20 = $[37];
    }
    const handleScenarioChange = t20;
    T5 = Box;
    t16 = "space-16";
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = {
        xs: "space-16",
        md: "space-24"
      };
      $[38] = t17;
    } else {
      t17 = $[38];
    }
    T4 = GlobalAlert;
    t12 = "div";
    t13 = false;
    t14 = "status";
    t15 = "warning";
    T3 = GlobalAlert.Content;
    T2 = VStack;
    t10 = "space-16";
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <div>Dette er en demoside og inneholder ikke dine personlige data.</div>;
      $[39] = t11;
    } else {
      t11 = $[39];
    }
    T1 = HStack;
    t7 = "space-16";
    t8 = true;
    let t21;
    if ($[40] !== handleVariantChange) {
      t21 = event => handleVariantChange(event.target.value);
      $[40] = handleVariantChange;
      $[41] = t21;
    } else {
      t21 = $[41];
    }
    let t22;
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = DEMO_TILTAKSPAKKE_VARIANT_OPTIONS.map(_temp);
      $[42] = t22;
    } else {
      t22 = $[42];
    }
    if ($[43] !== isPending || $[44] !== t21 || $[45] !== variant) {
      t9 = <Select disabled={isPending} label="Variant" onChange={t21} size="small" value={variant}>{t22}</Select>;
      $[43] = isPending;
      $[44] = t21;
      $[45] = variant;
      $[46] = t9;
    } else {
      t9 = $[46];
    }
    T0 = Select;
    t1 = isPending;
    t2 = "Scenario";
    if ($[47] !== handleScenarioChange) {
      t3 = event_0 => handleScenarioChange(event_0.target.value);
      $[47] = handleScenarioChange;
      $[48] = t3;
    } else {
      t3 = $[48];
    }
    t4 = "small";
    t5 = scenario;
    t6 = availableScenarios.map(_temp2);
    $[0] = isPending;
    $[1] = router;
    $[2] = scenario;
    $[3] = scenarios;
    $[4] = variant;
    $[5] = T0;
    $[6] = T1;
    $[7] = T2;
    $[8] = T3;
    $[9] = T4;
    $[10] = T5;
    $[11] = t1;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
    $[17] = t15;
    $[18] = t16;
    $[19] = t17;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    T0 = $[5];
    T1 = $[6];
    T2 = $[7];
    T3 = $[8];
    T4 = $[9];
    T5 = $[10];
    t1 = $[11];
    t10 = $[12];
    t11 = $[13];
    t12 = $[14];
    t13 = $[15];
    t14 = $[16];
    t15 = $[17];
    t16 = $[18];
    t17 = $[19];
    t2 = $[20];
    t3 = $[21];
    t4 = $[22];
    t5 = $[23];
    t6 = $[24];
    t7 = $[25];
    t8 = $[26];
    t9 = $[27];
  }
  let t18;
  if ($[49] !== T0 || $[50] !== t1 || $[51] !== t2 || $[52] !== t3 || $[53] !== t4 || $[54] !== t5 || $[55] !== t6) {
    t18 = <T0 disabled={t1} label={t2} onChange={t3} size={t4} value={t5}>{t6}</T0>;
    $[49] = T0;
    $[50] = t1;
    $[51] = t2;
    $[52] = t3;
    $[53] = t4;
    $[54] = t5;
    $[55] = t6;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  let t19;
  if ($[57] !== T1 || $[58] !== t18 || $[59] !== t7 || $[60] !== t8 || $[61] !== t9) {
    t19 = <T1 gap={t7} wrap={t8}>{t9}{t18}</T1>;
    $[57] = T1;
    $[58] = t18;
    $[59] = t7;
    $[60] = t8;
    $[61] = t9;
    $[62] = t19;
  } else {
    t19 = $[62];
  }
  let t20;
  if ($[63] !== T2 || $[64] !== t10 || $[65] !== t11 || $[66] !== t19) {
    t20 = <T2 gap={t10}>{t11}{t19}</T2>;
    $[63] = T2;
    $[64] = t10;
    $[65] = t11;
    $[66] = t19;
    $[67] = t20;
  } else {
    t20 = $[67];
  }
  let t21;
  if ($[68] !== T3 || $[69] !== t20) {
    t21 = <T3>{t20}</T3>;
    $[68] = T3;
    $[69] = t20;
    $[70] = t21;
  } else {
    t21 = $[70];
  }
  let t22;
  if ($[71] !== T4 || $[72] !== t12 || $[73] !== t13 || $[74] !== t14 || $[75] !== t15 || $[76] !== t21) {
    t22 = <T4 as={t12} centered={t13} role={t14} status={t15}>{t21}</T4>;
    $[71] = T4;
    $[72] = t12;
    $[73] = t13;
    $[74] = t14;
    $[75] = t15;
    $[76] = t21;
    $[77] = t22;
  } else {
    t22 = $[77];
  }
  let t23;
  if ($[78] !== T5 || $[79] !== t16 || $[80] !== t17 || $[81] !== t22) {
    t23 = <T5 paddingBlock={t16} paddingInline={t17}>{t22}</T5>;
    $[78] = T5;
    $[79] = t16;
    $[80] = t17;
    $[81] = t22;
    $[82] = t23;
  } else {
    t23 = $[82];
  }
  return t23;
}
function _temp2(t0) {
  const {
    value: value_2,
    label: label_0
  } = t0;
  return <option key={value_2} value={value_2}>{label_0}</option>;
}
function _temp(t0) {
  const {
    value: value_1,
    label
  } = t0;
  return <option key={value_1} value={value_1}>{label}</option>;
}